import { render, staticRenderFns } from "./ChartEff.vue?vue&type=template&id=f28d5ee4&scoped=true&"
import script from "./ChartEff.vue?vue&type=script&lang=js&"
export * from "./ChartEff.vue?vue&type=script&lang=js&"
import style0 from "./ChartEff.vue?vue&type=style&index=0&id=f28d5ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28d5ee4",
  null
  
)

export default component.exports
import {QCard,QCardSection,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QPage,QMarkupTable,QTable,QTh,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QDialog,QLayout,QHeader,QToolbar,QToolbarTitle,QBtn,QPageContainer,QPage,QMarkupTable,QTable,QTh}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
